import { atom } from 'recoil';
import { TRoomsParams } from 'common/types/floor-params.type';

export const roomsAtom = atom({
  key: 'rooms',
  default: [] as TRoomsParams[],
});
